import { storyblokEditable, StoryblokComponent } from "@storyblok/react";
import { useState, useEffect } from "react";

const MoodBannerWrap = ({ blok }) => {
  //ImageSlider

  const [arrowRightVisibility, setVisibilityArrwoRight] = useState("unset");
  const [arrowLeftVisibility, setVisibilityArrwoLeft] = useState("unset");
  let [translateXPosition, setTranslateXPosition] = useState(0);
  let [currentPosition, setCurrentPosition] = useState(0);
  let [count, setCount] = useState(0);
  const [controller, setController] = useState("src/pause-48.png");
  const [autoslide, setAutoslide] = useState(true);

  let calculatedLength = blok.banner.length;
  let autoslideSpeed = 5000;

  function hideLeftArrow() {
    if (currentPosition < 1) {
      setVisibilityArrwoLeft("hidden");
    } else if (currentPosition >= 1) {
      setVisibilityArrwoLeft("unset");
    }
  }

  function hideRightArrow() {
    if (currentPosition == blok.banner.length - 1) {
      setVisibilityArrwoRight("hidden");
    } else if (currentPosition < blok.banner.length - 1) {
      setVisibilityArrwoRight("unset");
    }
  }

  useEffect(() => {
    hideLeftArrow();
  }, [currentPosition]);

  useEffect(() => {
    if (
      currentPosition < calculatedLength - 1 &&
      !document.hidden
    ) {
      const intervalId = setInterval(() => {
        autoSlide();
        setCount((count) => count + 1);
      }, autoslideSpeed);
      return () => {
        clearInterval(intervalId);
      };
    } else if (
      currentPosition == calculatedLength - 1 &&
      !document.hidden
    ) {
      setTimeout(() => {
        setVisibilityArrwoLeft("hidden");
        setVisibilityArrwoRight("hidden");
        banner.style.animation = "stopSlider 2s";
      }, 3000);
      setTimeout(() => {
        banner.style.animation = "stopSlider 2s";
        resetAutoSlide();
      }, 5000);
    }
  }, [currentPosition]);

  function autoSlide() {
    const banner = document.getElementById("banner");
    if(banner){
    setTranslateXPosition((prevTranslateX) => prevTranslateX - 100);
    setCurrentPosition((prevPosition) => prevPosition + 1);
    banner.style.transition = "1.5s ease-in-out";
    }
  }

  function resetAutoSlide() {
    if(banner){
      banner.style.animation = "resetSlider 3s";
      setTranslateXPosition(0);
      banner.style.transition = "none";
      setTimeout(() => {
        /* setTranslateXPosition(0); */
        banner.style.transition = "1s ease-in-out";
        setVisibilityArrwoRight("unset");
        setCurrentPosition(0);
      }, autoslideSpeed);
    }
  
  }

  function slideRight() {
    const banner = document.getElementById("banner");

    if(banner){
      if (currentPosition < calculatedLength - 1) {
        setCurrentPosition((currentPosition += 1));
        setTranslateXPosition((translateXPosition -= 100));
        banner.style.transition = "0.5s ease-in-out";
        /*       console.log(currentPosition); */
      } else {
        setVisibilityArrwoLeft("hidden");
        setVisibilityArrwoRight("hidden");
        banner.style.animation = "stopSlider 1s";
        setTimeout(() => {
          banner.style.animation = "stopSlider 1s";
          setVisibilityArrwoRight("unset");
          resetAutoSlide();
        }, 1000);
      }
    }
  }

  function slideLeft() {
    const banner = document.getElementById("banner");
    if(banner){
      if (currentPosition >= 1) {
        setTranslateXPosition((translateXPosition += 100));
        banner.style.transition = "0.5s ease-in-out";
        setCurrentPosition((currentPosition -= 1));
      }
    }
  }

/*   function autoslideController() {
    if (autoslide) {
      setController("src/play-48.png");
      setAutoslide(false);
    } else {
      setController("src/pause-48.png");
      setAutoslide(true);
    }
  } */

  return (
    <div className="banner-wrap" {...storyblokEditable(blok)}>
      <div
        style={{ visibility: `${arrowLeftVisibility}` }}
        className="arrow-box-left-mood"
      >
        <img
          onClick={slideLeft}
          className="arrow-left-mood"
          src="/src/arrow-left-white-89-48.png"
          alt=""
        />
      </div>
      <div
        style={{ transform: `translateX(${translateXPosition}%)` }}
        id="banner"
        className="banner-nested-wrap"
      >
        {blok.banner.map((nestedBlok) => (
          <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
        ))}
      </div>
      <p className="d-none">Count: {count}</p>
      <div
        style={{ visibility: `${arrowRightVisibility}` }}
        className="arrow-box-right-mood"
      >
        <img
          onClick={slideRight}
          className="arrow-right-mood"
          src="/src/arrow-right-white-25-48.png"
          alt=""
        />
      </div>
      {/* <div className="autoslide-control-box">
        <img onClick={autoslideController} src={controller} alt=""></img>
      </div> */}
    </div>
  );
};

export default MoodBannerWrap;
